import {FormControl, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {IAccountInformationForm, IAddressForm, IOrganizationForm, IUserForm} from "./account-information-form.interface";
import {Country, ICity, IState} from "../../../../../../core/models/geography.model";
import {
    IAddress,
    IGetAccountInformationResponse
} from "../../../../../../core/api/controllers/account-controller/interfaces/get-account-information.response";

export class AccountInformationFormFactory {
    static create(): FormGroup<IAccountInformationForm> {
        return new FormGroup<IAccountInformationForm>({
            user: UserFormFactory.create(),
            organization: OrganizationFormFactory.create()
        });
    }

    static patchValue(form: FormGroup<IAccountInformationForm>, value: IGetAccountInformationResponse): void {
        UserFormFactory.patchValue(form.controls.user, value);
        OrganizationFormFactory.patchValue(form.controls.organization, value);
    }
}

export class UserFormFactory {
    static create(): FormGroup<IUserForm> {
        return new FormGroup<IUserForm>({
            firstName: new FormControl<string>('', [Validators.required]),
            lastName: new FormControl<string>('', [Validators.required]),
            phoneNumber: new FormControl('', [Validators.required]),
            email: new FormControl('', [Validators.required]),
        });
    }

    static patchValue(form: FormGroup<IUserForm>, value: IGetAccountInformationResponse): void {
        form.controls.lastName.patchValue(value.lastName);
        form.controls.firstName.patchValue(value.firstName);
        form.controls.phoneNumber.patchValue(value.phoneNumber);
        form.controls.email.patchValue(value.email);
    }
}

export class OrganizationFormFactory {
    static create(): FormGroup<IOrganizationForm> {
        return new FormGroup<IOrganizationForm>({
            organizationName: new FormControl<string>('', [Validators.required]),
            shippingAddress: AddressFormFactory.create(),
            billingAddress: AddressFormFactory.create(),
            organizationAddress: AddressFormFactory.create(),
        });
    }

    static patchValue(form: FormGroup<IOrganizationForm>, value: IGetAccountInformationResponse): void {
        form.controls.organizationName.patchValue(value.organizationName);
        AddressFormFactory.patchValue(form.controls.shippingAddress, value.shippingAddress);
        AddressFormFactory.patchValue(form.controls.billingAddress, value.billingAddress);
    }
}

export class AddressFormFactory {
    static create(): FormGroup<IAddressForm> {
        return new FormGroup<IAddressForm>({
            country: new FormControl<Country>(null, [Validators.required, ((control) => {
                if(typeof control.value === 'string') {
                    return {required: true};
                }
            }) as ValidatorFn]),
            state: new FormControl<IState>(null, [Validators.required, ((control) => {
                if(typeof control.value === 'string') {
                    return {required: true};
                }
            }) as ValidatorFn]),
            city: new FormControl<ICity>(null, [Validators.required]),
            addressLine1: new FormControl<string>("", [Validators.required]),
            addressLine2: new FormControl<string>(""),
            zipCode: new FormControl("")
        });
    }

    static patchValue(form: FormGroup<IAddressForm>, value: IAddress): void {
        form.controls.addressLine1.patchValue(value.addressLine1);
        form.controls.addressLine2.patchValue(value.addressLine2);
        form.controls.zipCode.patchValue(value.zipCode);
    }
}
